// ─── PASTE YOUR FIREBASE CONFIG HERE ─────────────────────────────────────────
// Go to Firebase Console → Project Settings → Your apps → Web app → Config
// Replace every value below with your actual project values
// ─────────────────────────────────────────────────────────────────────────────
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyC6waAF7ty5faqfdn3QNnUU7Ygv5R-vyHQ",
  authDomain: "clarion-b9328.firebaseapp.com",
  projectId: "clarion-b9328",
  storageBucket: "clarion-b9328.firebasestorage.app",
  messagingSenderId: "373435146193",
  appId: "1:373435146193:web:a8213698ed3093092c0af0",
  measurementId: "G-6PVMZHY5TS"
};

const app  = initializeApp(firebaseConfig);
export const db   = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
